// extracted by mini-css-extract-plugin
export default {"header":"LevelCard_header__H2nPf","title":"LevelCard_title__bzGsr","description":"LevelCard_description__UFq9K"};